import { VENDOR, VENDORS } from '..';
import AttractorDisplay from './AttractorDisplay';
import { KioskAttractorsResponse } from '../types';

const KioskAttractorDisplayPreview = ({
  currentAttractors,
  blobIsVideo = false,
}: {
  currentAttractors: KioskAttractorsResponse[] | { imageUrl: string }[];
  blobIsVideo?: boolean;
}) => {
  return (
    <div className="relative h-[30rem] w-[15rem]">
      <AttractorDisplay
        currentAttractors={currentAttractors}
        blobIsVideo={blobIsVideo}
      />
      {VENDOR === VENDORS.PE ? (
        <img src={'/pe_custom_kiosk.png'} className="h-full w-full" />
      ) : (
        <img src={'/nobrand_kiosk.png'} className="h-full w-full" />
      )}
    </div>
  );
};

export default KioskAttractorDisplayPreview;
